module.exports = __webpack_public_path__ + "static/entrance-ba8ca0028045446ec36c2a54d1f4fe68.webp";